import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

export default {
    name: 'SurveyItemsAllAggregation',
    productArea: PRODUCT_AREAS.SURVEYS,
    subProductArea: SUB_PRODUCT_AREAS.GENERAL,
    responseFormat: 'rows',
    build: () => {
        return o.pipeline(
            o.sources.surveyItems(null),
            o.filter('surveyItemType != "BASIC"'),
        );
    },
};
